import apiWorker from '../apiWorker'

export default {

    update    : (case_id, data)         => apiWorker('patch',  `/api/v1/core/cases/update/${case_id}`, data),
    find      : (query, hideError)      => apiWorker('get',  `/api/v1/core/cases/find${query}`, null, hideError),
    findById  : (case_id, hideError)    => apiWorker('get',  `/api/v1/core/cases/find/${case_id}`, null,  hideError),

}
